import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "The Art of Belonging",
    desc: "Every residence arrives fully furnished — plush textiles, equipped kitchens and living essentials — so you settle in from the very first day.",
  },
  {
    num: "02",
    title: "Boutique Restraint",
    desc: "No crowded lobbies, no generic rentals. Each Parker stay is a private, thoughtfully kept home tailored for focus, rest and gathering.",
  },
  {
    num: "03",
    title: "Southern Ease",
    desc: "From Baker to Ascension Parish, timeless Louisiana hospitality meets modern convenience — work-friendly, family-ready, quietly refined.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="bg-[#f7f2e7]/90 text-[#16301f]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-16 sm:mb-20"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#16301f]/60 flex items-center gap-4">
            <span className="h-px w-12 bg-[#16301f]/40 inline-block" />
            Our Manifesto
          </p>
          <h2 className="font-display font-medium text-4xl sm:text-5xl mt-6">Why guests stay</h2>
          <p className="font-script text-3xl sm:text-4xl text-[#1a3324] mt-3 -rotate-1 inline-block">
            Thoughtfully furnished. Beautifully lived in.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-10 md:gap-8 lg:gap-14">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.14, ease: EASE }}
              className="border-t border-[#16301f]/15 pt-8 group"
            >
              <p className="font-display text-5xl sm:text-6xl text-[#16301f]/25 group-hover:text-[#16301f]/45 transition-colors duration-500">
                {c.num}
              </p>
              <h3 className="font-display text-2xl mt-5">{c.title}</h3>
              <p className="text-sm leading-relaxed text-[#16301f]/70 font-light mt-3">{c.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
